(() => {
  const component = document.querySelector('[data-vdm-localization-suggestion]');

  if (!component || window.Shopify?.designMode) return;

  const storageKey = 'vdm-localization-suggestion-v1';
  const decisionLifetime = 30 * 24 * 60 * 60 * 1000;
  const currentCountry = component.dataset.currentCountry;
  const currentLanguage = component.dataset.currentLanguage;
  const availableCountries = new Set((component.dataset.availableCountries || '').split(',').filter(Boolean));
  const availableLanguages = new Set((component.dataset.availableLanguages || '').split(',').filter(Boolean));

  const rememberDecision = (action) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ action, timestamp: Date.now() }));
    } catch (_error) {
      // The suggestion still works when storage is unavailable.
    }
  };

  const hasRecentDecision = () => {
    try {
      const decision = JSON.parse(localStorage.getItem(storageKey));
      return Boolean(decision?.timestamp && Date.now() - decision.timestamp < decisionLifetime);
    } catch (_error) {
      return false;
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('localization-form-component [data-value]')) {
        rememberDecision('manual');
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      if (event.target.matches('select[name="language_code"], select[name="country_code"]')) {
        rememberDecision('manual');
      }
    },
    true
  );

  if (hasRecentDecision()) return;

  const root = window.Shopify?.routes?.root || '/';
  const query = new URLSearchParams({
    'country[enabled]': 'true',
    'country[exclude]': currentCountry,
    'language[enabled]': 'true',
    'language[exclude]': currentLanguage,
  });

  fetch(`${root}browsing_context_suggestions.json?${query.toString()}`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Localization suggestion failed: ${response.status}`);
      return response.json();
    })
    .then((payload) => {
      const suggestion = payload.suggestions?.[0]?.parts;
      const detectedCountry = payload.detected_values?.country;
      const suggestedCountry = suggestion?.country;
      const suggestedLanguage = suggestion?.language;

      if (!suggestion || !detectedCountry) return;

      const preferredLanguage = detectedCountry.handle === 'ES' ? 'es' : detectedCountry.handle === 'IT' ? 'it' : 'en';
      const fallbackLanguage = availableLanguages.has('en') ? 'en' : currentLanguage;
      const targetLanguage = availableLanguages.has(preferredLanguage) ? preferredLanguage : fallbackLanguage;
      const recommendedCountry = suggestedCountry?.handle;
      const targetCountry = availableCountries.has(recommendedCountry) ? recommendedCountry : currentCountry;

      if (targetCountry === currentCountry && targetLanguage === currentLanguage) return;

      const languageName =
        suggestedLanguage?.options?.[targetLanguage] ||
        new Intl.DisplayNames([currentLanguage], { type: 'language' }).of(targetLanguage) ||
        targetLanguage.toUpperCase();
      const regionName =
        suggestedCountry?.options?.[targetCountry] ||
        suggestedCountry?.name ||
        new Intl.DisplayNames([currentLanguage], { type: 'region' }).of(targetCountry) ||
        targetCountry;
      const message = component.dataset.messageTemplate
        .replace('__country__', detectedCountry.name)
        .replace('__region__', regionName)
        .replace('__language__', languageName);

      component.querySelector('[data-vdm-localization-message]').textContent = message;
      component.hidden = false;

      component.querySelector('[data-vdm-localization-dismiss]').addEventListener('click', () => {
        rememberDecision('dismissed');
        component.hidden = true;
      });

      component.querySelector('[data-vdm-localization-accept]').addEventListener('click', () => {
        rememberDecision('accepted');

        const form = document.createElement('form');
        form.hidden = true;
        form.method = 'post';
        form.action = '/localization';

        const fields = {
          _method: 'PUT',
          country_code: targetCountry,
          language_code: targetLanguage,
        };

        Object.entries(fields).forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      });
    })
    .catch((error) => {
      console.warn('[VDM] Localization suggestion unavailable.', error);
    });
})();
